import { NOTE_MAX_LENGTH } from "Components/Analyses/constants";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, number, object, string } from "yup";
import { type AssetAllocationFields, createAssetAllocationSchema } from "../helpers";

export type CommoditiesFormType = AssetAllocationFields & {
  readonly investmentToolType: string;
  readonly institution?: string;
  readonly investmentAmount: number;
  readonly horizon: number;
  readonly appreciationRate: number;
  readonly brand: string;
  readonly ingotWeight: string;
  readonly ingotCount: number;
  readonly entryFee?: number;
  readonly regularAmount: number;
  readonly proposedStepAction: string;
  readonly note?: string;
};

export const getCommoditiesFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
  requireCharacteristics?: boolean,
) => ObjectSchema<CommoditiesFormType> = (t, requireCharacteristics) => {
  return object({
    investmentToolType: string().required(t(Resources.Validation.Required)),
    institution: string().optional(),
    investmentAmount: number().required(t(Resources.Validation.Required)),
    horizon: number().required(t(Resources.Validation.Required)),
    appreciationRate: number().required(t(Resources.Validation.Required)).max(100, t(Resources.Validation.PercentMax)),
    brand: string().required(t(Resources.Validation.Required)),
    ingotWeight: string().required(t(Resources.Validation.Required)),
    ingotCount: number().required(t(Resources.Validation.Required)),
    entryFee: number().optional().max(100, t(Resources.Validation.PercentMax)),
    regularAmount: number().required(t(Resources.Validation.Required)),
    ...createAssetAllocationSchema(t, requireCharacteristics),
    proposedStepAction: string().required(t(Resources.Validation.Required)),
    note: string().max(NOTE_MAX_LENGTH, t(Resources.Validation.String.Max, { count: NOTE_MAX_LENGTH })),
  }).defined();
};
